export const CONFIG_CONSTANTS = {
    siteIdKey: 'siteId',
    apiUrlKey: 'webApiUrl',
    envKey: 'environment',
    defaultVersionKey: 'webApiDefaultVersion',
    prodEnvValue: 'production',
    cdnListKey: 'cdnList',
    cdnPathKey: 'cdnPath',
};

export const LOGIN_URL = '/login';

export const API_CONSTANTS = {
    authEndpoint: 'authz/public',
    authStatusEndpoint: 'authentication/status',
    createPersonalScheduleItemEndpoint: 'keyring-service/personal-schedule-item',
    currencyExchangeRateEndpoint: 'convert-currency/exchange-rate',
    friendsAndFamilyEndpoint: 'keyring-service/friends-and-family',
    listSvcEndpoint: 'list-service/details-slugs',
    webApiVersionEndpoint: 'version',
    resourceBundleEndpoint: 'language-bundles',
    jwtCookieName: 'pep_jwt_token',
    personalizedContentEndpoint: 'recommendation-service/personalized-content',
    mediaListEndpoint: 'media-list'
};

// Any locale date formats should be in lower case without dashes or underscores
export const SCHEDULE_CONSTANTS = {
    fullDateFormat: 'dddd, MMMM D, YYYY',
    ptbrFullDateFormat: 'dddd, D [de] MMMM [de] YYYY',
    scheduleDateFormat: 'YYYY-MM-DD',
    operating: 'Operating',
    refurbishment: 'Refurbishment',
    extraMagicHours: 'Extra Magic Hours',
    extraMagicHourMagicMorning: 'Extra Magic Hour and Magic Morning',
    specialTicketedEvent: 'Special Ticketed Event',
    closed: 'Closed',
    performanceTime: 'Performance Time',
    noPerformance: 'No Performance',
    timeOutputFormat: 'h:mm A',
    timeParseFormat: 'HH:mm:ss',
    scheduleTimesThreshold: 3
};

export const MEDIA_ENGINE_CONSTANTS = {
    selectors: {
        titleBarClass: 'me-title-bar',
        titleClass: 'me-title',
        ctaBtnClass: 'me-cta-btn',
        fsBtnClass: 'me-fs-btn',
        headerMeFsClass: 'me-fullscreen',
        headerClass: 'syndicated-header-wrapper'
    }
};

export const DESTINATION_ID_CONSTANTS = {
    wdw: '80007798;entityType=destination',
    dlr: '80008297;entityType=destination'
};

export const LIST_RESOLVER_FILTER_MAP = {
    attractions: ['Attraction', 'Entertainment'],
    entertainment: ['Attraction', 'Entertainment'],
};

export const LIST_TITLE_MAP = {
    attractions: 'Attractions and Entertainment',
    entertainment: 'Attractions and Entertainment',
};

export const DESTINATION_NAME_CONSTANTS = {
    wdw: 'Walt Disney World',
    dlr: 'Disneyland Resort'
};

export const MEAL_PERIOD_CONSTANTS = {
    mealPeriodsOrder: [
        'breakfast',
        'brunch',
        'lunch',
        'dinner',
        'lounge',
        'late-night'
    ]
};

export const LOCALES = {
    en_US: 'en_US', // united states
    en_es: 'en-es', // spanish in us
    en_CA: 'en_CA', // canada
    fr_ca: 'fr-ca', // french
    es_ar: 'es-ar', // argentina
    es_mx: 'es-mx', // mexico
    en_eu: 'en-eu', // europe
    en_GB: 'en_GB', // uk
    jp: 'jp',       // japan
    es_pe: 'es-pe', // peru
    es_co: 'es-co', // colombia
    es_cl: 'es-cl', // chile
    pt_br: 'pt-br', // brasil
    en_IE: 'en_IE'  // ireland
};
